import React, { useEffect, useState } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import MemberTable from "views/admin/member/components/MemberTable";
import { Pagination, Row } from "antd";
import { Controller } from "Controller/Controller";

const tableColumnsTopCreators = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

const tableColumnsTopCreatorsInvite = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
];

const tableColumnsTopCreatorsBusiness = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "address",
    accessor: "address",
  },
  {
    Header: "city",
    accessor: "city",
  },
  {
    Header: "state",
    accessor: "state",
  },
  {
    Header: "Contact Person",
    accessor: "contact_person",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

const Member = () => {
  const [members, setMembers] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [current, setCurrent] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [showList, setShowList] = useState("member"); // "member" | "invite"
  const [memberType, setMemberType] = useState("individual");
  const [loading, setLoading] = useState(true);

  const getMemberData = async () => {
    setLoading(true);

    const normalizedSearch = searchTerm.trim();
    const searchValue = normalizedSearch === "" ? undefined : normalizedSearch;

    if (showList === "member") {
      if (memberType === "individual") {
        const response = await Controller.GetCustomers(current, searchValue);
        if (response.status < 250) {
          let tempMembers = response.json.results || [];
          const hasBusinessMemberFlag = tempMembers.some(
            (member) => typeof member?.business_member === "boolean"
          );
          if (hasBusinessMemberFlag) {
            tempMembers = tempMembers.filter(
              (member) => member.business_member === false
            );
          }
          setPageCount(response.json.count);
          setMembers(tempMembers);
        }
      } else {
        const response = await Controller.readBusinessMember(current);
        if (response.status < 250) {
          let tempMembers = response.results || [];
          const hasBusinessMemberFlag = tempMembers.some(
            (member) => typeof member?.business_member === "boolean"
          );
          if (hasBusinessMemberFlag) {
            tempMembers = tempMembers.filter(
              (member) => member.business_member === true
            );
          }
          if (searchValue) {
            const normalizedBusinessSearch = searchValue.toLowerCase();
            tempMembers = tempMembers.filter((member) => {
              const fullName =
                (member?.first_name ? member.first_name : "") +
                " " +
                (member?.last_name ? member.last_name : "");
              const contactPersonName =
                (member?.contact_person?.first_name
                  ? member.contact_person.first_name
                  : "") +
                " " +
                (member?.contact_person?.last_name
                  ? member.contact_person.last_name
                  : "");
              return (
                fullName.toLowerCase().includes(normalizedBusinessSearch) ||
                contactPersonName
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.business_name || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.email || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.phone || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.address || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.city || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.state || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.contact_person?.email || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch) ||
                (member?.contact_person?.phone || "")
                  .toLowerCase()
                  .includes(normalizedBusinessSearch)
              );
            });
          }
          setPageCount(
            searchValue ? tempMembers.length : response.count || tempMembers.length
          );
          setMembers(tempMembers);
        }
      }
    } else {
      const response = await Controller.readInvitedList(current);
      if (response.status < 250) {
        setPageCount(response.json.count);
        setMembers(response.json.results || []);
      }
    }

    setLoading(false);
  };

  const onPageChange = (page) => {
    setCurrent(page);
  };

  const onSearch = (value = "") => {
    const normalizedValue = value.trim();
    setCurrent(1);
    setSearchTerm(normalizedValue);
  };

  const handleMemberTypeChange = (value) => {
    setCurrent(1);
    setMemberType(value);
  };

  useEffect(() => {
    getMemberData();
  }, [current, searchTerm, showList, memberType]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid>
        <Card px="0px" mb="20px">
          <MemberTable
            loading={loading}
            tableData={members}
            columnsData={
              memberType === "individual"
                ? tableColumnsTopCreators
                : tableColumnsTopCreatorsBusiness
            }
            columnsDataInvite={tableColumnsTopCreatorsInvite}
            getMemberData={getMemberData}
            showList={showList}
            setShowList={setShowList}
            onSearch={onSearch}
            memberType={memberType}
            setMemberType={handleMemberTypeChange}
          />

          <Row justify="center" style={{ marginTop: 12 }}>
            <Pagination
              showSizeChanger={false}
              current={current}
              total={pageCount}
              hideOnSinglePage
              onChange={onPageChange}
            />
          </Row>
        </Card>
      </SimpleGrid>
    </Box>
  );
};

export default Member;
